import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import './App.css';
import TopBar from './containers/TopBar/TopBar';
import AppsShowcase from './containers/AppsShowcase/AppsShowcase';
import Contact from './containers/Contact/Contact';
import BottomBar from './containers/BottomBar/BottomBar';
import Intro from './containers/Intro/Intro';
import Policy from './containers/Policy/Policy';


class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    return (
      <Router>
        <Switch>
          <Route path='/policy'>
            <Policy/>
          </Route>
          <Route path='/'>
            <div className="App">
              <TopBar />
              <Intro width={this.state.width} height={this.state.height} />
              <AppsShowcase />
              <Contact />
              <BottomBar />
            </div>
          </Route>
        </Switch>
      </Router>

    );
  }

}

export default App;
